var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order-card"
  }, [_c('div', {
    staticClass: "px-4 py-4 flex justify-between items-center gap-6 shadow-border-b mdmax:px-4 mdmax:py-4"
  }, [_vm.isMobile ? _c('span', {
    staticClass: "inline-block cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.expand();
      }
    }
  }, [_c('Chevron', {
    attrs: {
      "direction": "down"
    }
  })], 1) : _vm._e(), !_vm.isMobile ? _c('div', {
    staticClass: "flex items-center gap-6"
  }, [_vm.data.delivery_service.delivery_service_logo ? _c('img', {
    staticClass: "max-h-14",
    attrs: {
      "src": _vm.data.delivery_service.delivery_service_logo
    }
  }) : _c('LogisticPlaceholder', {
    attrs: {
      "logisticName": _vm.data.delivery_service.delivery_service_name
    }
  }), _vm.data.delivery_service.delivery_service_name ? _c('span', {
    staticClass: "text-xs text-secondary-500 bg-secondary-200 py-1 px-2 rounded-md text-center"
  }, [_vm._v(_vm._s(_vm.data.delivery_service.delivery_service_name) + " (" + _vm._s(_vm.data.delivery_service.delivery_service_package_name) + ")")]) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "flex gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.uploadOrderCard.editButton'),
      "type": 'secondary',
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": _vm.editOnClick
    }
  }), _c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.uploadOrderCard.deleteButton'),
      "type": 'delete',
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.handleDeleteTempOrder(_vm.data.id);
      }
    }
  })], 1)]), _c('div', {
    staticClass: "flex justify-between items-start shadow-border-b text-neutral-500 mdmax:flex-col mdmax:shadow-none",
    class: {
      hidden: !_vm.visibleContent && _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "w-2/5 border-r p-4 mdmax:w-full mdmax:p-4 mdmax:border-none mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-start gap-6 mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-2/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.senderName')))]), _c('p', {
    staticClass: "font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden",
    attrs: {
      "title": _vm.data.sender.sender_name
    }
  }, [_vm._v(_vm._s(_vm.data.sender.sender_name))]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(_vm._s(_vm.data.sender.sender_phone))])]), _c('div', {
    staticClass: "w-3/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.senderAddress')))]), _c('p', {
    staticClass: "ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
  }, [_vm._v(_vm._s(_vm.data.sender.sender_address))])])]), _c('div', {
    staticClass: "mt-4 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(_vm.data.pickup_detail || '-'))])])]), _c('div', {
    staticClass: "w-2/5 border-r p-4 mdmax:border-none mdmax:p-4 mdmax:w-full mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-start gap-6 mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-2/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700 whitespace-nowrap"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.receiverName')))]), _c('p', {
    staticClass: "font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden",
    attrs: {
      "title": _vm.data.receiver.receiver_name
    }
  }, [_vm._v(_vm._s(_vm.data.receiver.receiver_name))]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(_vm._s(_vm.data.receiver.receiver_phone))])]), _c('div', {
    staticClass: "w-3/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.receiverAddress')))]), _c('p', {
    staticClass: "ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
  }, [_vm._v(_vm._s(_vm.data.receiver.receiver_address))])])]), _c('div', {
    staticClass: "mt-4 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.detailShipping')))]), _c('p', [_vm._v(_vm._s(_vm.data.destination_detail || '-'))]), _c('p', {
    staticClass: "text-xs italic text-red-500"
  }, [_vm._v(_vm._s(_vm.data.errors.destination))])])]), _c('div', {
    staticClass: "w-1/5 p-4 mdmax:w-full mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.weight')))]), _c('p', [_vm._v(_vm._s(_vm.data.goods.goods_weight) + " kg")])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.goodsCategory')))]), _c('p', [_vm._v(_vm._s(_vm.data.goods.goods_category))])]), _c('div', {}, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.price')))]), _c('p', [_vm._v(_vm._s(_vm.formatCurrency(_vm.data.price)))]), _c('p', {
    staticClass: "text-xs italic text-red-500"
  }, [_vm._v(_vm._s(_vm.data.errors.serviceCost))])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }